module.exports = __webpack_public_path__ + "img/api_psd2_pagos.93eabe61.svg";